import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { compose } from 'recompose';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import classNames from 'classnames';

import * as NotificationActions from '../../../components/Notifications/actions';
import * as dateHelper from '../../../lib/dates';
import * as styles from './styles.css';
import InfoToolTip from '../../InfoToolTip';
import { withTranslation } from 'react-i18next';

class DateCommandInput extends Component {
  static propTypes = {
    onChange: PropTypes.func.isRequired,
    addError: PropTypes.func.isRequired,
  };

  constructor(props) {
    super(props);
    this.state = {
      value: '',
      error: false,
    };
  }

  dates = (input) => {
    try {
      const weeks = dateHelper.getWeeksFromString(input);
      return dateHelper.selectWeekdays(null, dateHelper.getDatesForWeeks(weeks));
    } catch ({ message }) {
      this.props.addError({ message });
      return [];
    }
  };

  handleKeyPress({ target: { value }, key }) {
    if (key !== 'Enter') {
      return;
    }

    if (!value) {
      return;
    }

    const dates = this.dates(value);
    if (!dates || dates.length === 0) {
      this.setState({ error: true });
      return;
    }

    this.setState({ value: '' });
    this.props.onChange(dates);
  }

  handleChange({ target: { value } }) {
    this.setState({ value });
    if (this.state.error) {
      this.setState({ error: false });
    }
  }

  render() {
    return (
      <div className={classNames('form-group', styles.dateCommandInput, { 'has-error': this.state.error })}>
        <input
          data-testid="DateCommandInput"
          className={'form-control'}
          placeholder={this.props.t("Specificera veckospann, exempelvis: 2018:32-2018:39")}
          value={this.state.value}
          onKeyPress={event => this.handleKeyPress(event)}
          onChange={event => this.handleChange(event)}
        />
        <InfoToolTip title="Veckospann">
          {this.props.t("När du valt veckospann, tryck enter")}
        </InfoToolTip>
      </div>
    );
  }
}

export { DateCommandInput as DateCommandInputTest };

export default compose(
  connect(null,
    dispatch => bindActionCreators({
      addError: NotificationActions.addError,
    }, dispatch),
  ),
)(withTranslation()(DateCommandInput));
